import '../../style/index.less';
import './index.less'; // style dependencies

import '../../tooltip/style';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/slider/style/index.js
// module id = 1426
// module chunks = 0